import { useMinerAccount } from '@/processes/MinerAccounts';
import { useGetPayoutAddressQuery } from '@/shared/api/accounts';

export const usePayoutData = () => {
  const { account, coin, isAccountMining } = useMinerAccount();
  const { payoutAddress, isError } = useGetPayoutAddressQuery({ account, coin }, { 
    skip: !account || !coin || !isAccountMining,
    selectFromResult: ({ data, isError }) => ({
      payoutAddress: data?.address || {},
      isError,
    }),
  });
  return isError ? {} : payoutAddress;
}
